export default __webpack_public_path__ + "static/loader-4d2e9c434a578b213778100bee1458b1.gif";